//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateEmail } from "@/utils/validations.js";
import BackendServices from "@/services/backend-services";

export default {
  name: "PermissionsManagementForm",
  components: {},
  props: ["selectedRow"],
  mounted: async function () {
    await BackendServices.getAvailablePermissionsList().then((response) => {
      this.availablePermissions = response.data;
    });
    this.selectedPermissions = this.selectedRow.permissions;
    this.name = this.selectedRow.name;
  },
  data() {
    return {
      validForm: false,
      name: "",
      id: null,
      availablePermissions: [],
      selectedPermissions: [],
    };
  },
  methods: {
    required,
    noValidation,
    validateEmail,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      this.$emit("save-permission", {
        role: {
          id: this.selectedRow.id,
          name: this.name,
          permissions: this.selectedPermissions,
        },
      });
    },
  },
  watch: {
    name() {
      this.updateData();
    },
    selectedPermissions() {
      this.updateData();
    },
    selectedRow() {
      this.selectedPermissions = this.selectedRow.permissions;
      this.name = this.selectedRow.name;
    },
  },
};
